import { apiClient } from './client';
import type { AuthUser } from '@/stores/authStore';

export interface AuthResponse {
  accessToken: string;
  user: AuthUser;
}

export async function loginRequest(email: string, password: string): Promise<AuthResponse> {
  const res = await apiClient.post<{ data: AuthResponse }>('/auth/login', { email, password });
  return res.data.data;
}

export async function registerRequest(input: {
  email: string;
  password: string;
  displayName: string;
  locale?: 'tr' | 'en';
}): Promise<AuthResponse> {
  const res = await apiClient.post<{ data: AuthResponse }>('/auth/register', input);
  return res.data.data;
}

export async function logoutRequest(): Promise<void> {
  await apiClient.post('/auth/logout');
}

export async function meRequest(): Promise<AuthUser> {
  const res = await apiClient.get<{ data: AuthUser }>('/auth/me');
  return res.data.data;
}

export async function forgotPasswordRequest(email: string): Promise<void> {
  await apiClient.post('/auth/forgot', { email });
}

export async function resetPasswordRequest(token: string, newPassword: string): Promise<void> {
  await apiClient.post('/auth/reset', { token, newPassword });
}
